export type MmkCategory =
  | "Indication"
  | "Dosing"
  | "Safety"
  | "Efficacy"
  | "Patient Selection"
  | "Differentiation";

export type MmkItemSource = "catalog" | "personal";

export type MmkFilterCategory = "All" | "Personal" | MmkCategory;
export type MmkViewMode = "grid" | "scroll";
export type MmkSortOrder = "oldest_first" | "newest_first";
export type MmkStatus = "default" | "pinned" | "review_later" | "known";

export interface MmkItem {
  id: string;
  source?: MmkItemSource;
  mkk_id?: string;
  therapy_area?: string;
  mkk_number: string;
  title: string;
  question?: string;
  content: string;
  approved_answer?: string;
  short_answer?: string | null;
  source_ref?: string;
  status?: MmkStatus;
  last_seen_at?: string;
  last_action_at?: string;
  is_mastered: boolean;
  is_pinned?: boolean;
  is_review_later?: boolean;
  category: MmkCategory | null;
}

export const MMK_FILTER_CATEGORIES: MmkFilterCategory[] = [
  "All",
  "Personal",
  "Indication",
  "Dosing",
  "Safety",
  "Efficacy",
  "Patient Selection",
  "Differentiation",
];

export type MmkFocusSessionCategory = Exclude<MmkFilterCategory, "All">;

export type FocusSessionVariant = "quick_5" | "by_category" | "mixed";

export type QuizQuestionType = "multiple_choice" | "true_false";

export interface QuizOption {
  text: string;
  correct: boolean;
}

export interface QuizQuestion {
  item_id: string;
  mkk_number?: string;
  card_header_label?: string;
  question: string;
  question_type: QuizQuestionType;
  options: QuizOption[];
  category: MmkCategory;
  approved_answer: string;
}

export interface QuizItemsResponse {
  questions: QuizQuestion[];
}

export interface QuizCompletePayload {
  score: number;
  total: number;
  correct_ids: string[];
  wrong_ids: string[];
  category_breakdown?: Record<
    string,
    { correct: number; wrong: number }
  >;
}

// GET /mkk/personal_cards
export interface PersonalCardApi {
  id: string;
  question: string;
  approved_answer: string;
  short_answer?: string | null;
  category?: MmkCategory | null | "";
  is_personal?: boolean;
  status?: MmkStatus;
  last_seen_at?: string;
  last_action_at?: string;
  is_pinned?: boolean;
  is_review_later?: boolean;
  is_mastered?: boolean;
}

export interface PersonalCardsResponse {
  personal_cards: PersonalCardApi[];
}

// POST /mkk/personal_cards — `category: null` when user chose “No category”.
export interface PersonalCardSavePayload {
  id: string;
  question: string;
  approved_answer: string;
  short_answer?: string | null;
  category: MmkCategory | null;
}

export const FOCUS_SESSION_VARIANTS: {
  id: FocusSessionVariant;
  label: string;
  description: string;
}[] = [
  {
    id: "quick_5",
    label: "Quick 5",
    description: "5 random cards to review",
  },
  {
    id: "by_category",
    label: "By category",
    description: "MMM from selected category only",
  },
  {
    id: "mixed",
    label: "Mixed",
    description: "Pinned and To Review cards",
  },
];
